module.exports = __webpack_public_path__ + "static/media/icon_02.5b22d487.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_02.png
// module id = 1643
// module chunks = 1